import { faker } from '@faker-js/faker'

const state = {
  bookingList: {
    bookingId: null,
    profileId: null,
    accountId: null
  }
}

const getters = {
  getRandomUUID: () => () => {
    return faker.datatype.uuid()
  },
  getUUIDNode: () => (uuid) => {
    return uuid ? uuid.substr(uuid.length - 12) : null
  }
}

const actions = {}

const mutations = {
  generateRandomUUIDs (state) {
    Object.keys(state.bookingList).forEach(key => {
      state.bookingList[key] = faker.datatype.uuid()
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}